import { render, staticRenderFns } from "./dlt_sss_yc.vue?vue&type=template&id=21d39882&scoped=true"
import script from "./dlt_sss_yc.vue?vue&type=script&lang=js"
export * from "./dlt_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./dlt_sss_yc.vue?vue&type=style&index=0&id=21d39882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d39882",
  null
  
)

export default component.exports